import classNames from 'classnames'

import { getQaSelector } from '../../../../utils/common'
import { FilePreview } from '../../../File'
import { QA_NAME_PHOTO_TILE } from '../RentalPortalPhotoGallery.constants'
import { getPhotoImageSrc } from '../RentalPortalPhotoGallery.utils'
import { RentalPortalPhotoGalleryTileOverlay } from '../RentalPortalPhotoGalleryTileOverlay'

import { useRentalPortalPhotoGalleryTile } from './RentalPortalPhotoGalleryTile.hooks'
import { RentalPortalPhotoGalleryTileUploadState } from './RentalPortalPhotoGalleryTileUploadState'

import * as styles from './RentalPortalPhotoGalleryTile.module.css'

function RentalPortalPhotoGalleryTile({
  disabled,
  disabledReason,
  hasReorder,
  isCover,
  isReorderDisabled,
  photo,
  position,
  reorderDisabledReason,
  onClick,
  onDelete,
  onRetry,
  onSetCover,
}) {
  const {
    handleClick,
    handleDelete,
    handleRetry,
    handleSetCover,
    hasError,
    isUploading,
    photoName,
  } = useRentalPortalPhotoGalleryTile({
    photo,
    onClick,
    onDelete,
    onRetry,
    onSetCover,
  })

  const tileClassName = classNames(styles.RentalPortalPhotoGalleryTile, {
    [styles.errorTile]: hasError,
  })

  const overlayProps = {
    disabledReason,
    hasReorder,
    isCover,
    isReorderDisabled,
    position,
    reorderDisabledReason,
    onOpen: handleClick,
    onSetCover: handleSetCover,
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_PHOTO_TILE })}
      className={tileClassName}
    >
      {hasError || isUploading ? (
        <RentalPortalPhotoGalleryTileUploadState
          disabled={disabled}
          disabledReason={disabledReason}
          hasError={hasError}
          photo={photo}
          photoName={photoName}
          onRemove={handleDelete}
          onRetry={handleRetry}
        />
      ) : (
        <FilePreview
          ErrorPreviewImageOverlay={RentalPortalPhotoGalleryTileOverlay}
          Overlay={RentalPortalPhotoGalleryTileOverlay}
          className={styles.preview}
          disabled={disabled}
          errorImagePreviewProps={overlayProps}
          file={photo}
          getImageSrc={getPhotoImageSrc}
          overlayProps={overlayProps}
          onClick={handleClick}
          onRemoveFile={handleDelete}
        />
      )}
    </div>
  )
}

export default RentalPortalPhotoGalleryTile
